import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(new Date(date));
}

export function formatDateTime(date) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(new Date(date));
}

export function getStatusColor(status) {
  const statusColors = {
    'created': 'bg-gray-100 text-gray-700',
    'received': 'bg-blue-100 text-blue-700',
    'sorted': 'bg-indigo-100 text-indigo-700',
    'dispatched': 'bg-purple-100 text-purple-700',
    'in_transit': 'bg-cyan-100 text-cyan-700',
    'out_for_delivery': 'bg-yellow-100 text-yellow-700',
    'delivered': 'bg-green-100 text-green-700',
    'failed': 'bg-red-100 text-red-700',
    'returned': 'bg-orange-100 text-orange-700',
    'cancelled': 'bg-gray-100 text-gray-700'
  };
  return statusColors[status] || 'bg-gray-100 text-gray-700';
}

export function generateTrackingId() {
  const prefix = 'EZP';
  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).substring(2, 7).toUpperCase();
  return `${prefix}-${timestamp}-${random}`;
}